import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Recommended} from '../../../../../models/search/filter/recommended';
import {QueryStringService} from '../../../../../services/query-string.service';

@Component({
  selector: 'app-recommended',
  templateUrl: './recommended.component.html',
})
export class RecommendedComponent implements OnInit {

  @Input() data: Recommended[];
  @Output() update = new EventEmitter<any>();

  constructor(
      private QSS: QueryStringService
  ) { }

  ngOnInit() {
  }

  isActive(item: Recommended) {

    const arr = this.getArrayFromFilters(item.filters);

    for (const filter of arr) {
      if (this.QSS.getParam(filter.name) !== filter.value) {
        return false;
      }
    }
    return true;
  }

  updateEvent($event: Event, item: Recommended) {
    if (item === null) {
      const arr = this.getArrayFromFilters('');

      for (const filter of arr) {
        this.update.emit({name: filter.name, 'value': null});
      }
    } else {
      if (!$($event.target).hasClass('icon-x') && !$($event.target).hasClass('btn-delete')) {
        if (!this.isActive(item)) {
          const arr = this.getArrayFromFilters(item.filters);

          for (const filter of arr) {
            this.update.emit({name: filter.name, 'value': filter.value});
          }
        }
      }
    }
  }

  private getArrayFromFilters(filters: string): any[] {
    const result = [];
    const obj = {};

    if (filters[0] === '?') {
      filters = filters.substr(1);
    }

    for (const part of filters.split('&')) {
      const filterName = part.split('=')[0];
      const filterValue = part.split('=').slice(1).join('=');

      obj[filterName] = filterValue;
    }

    for (const name of this.getSearchFilterNames()) {
      if (obj[name] && obj[name].length > 0) {
        result.push({name, value: obj[name]});
      } else {
        result.push({name, value: null});
      }
    }

    return result;
  }

  getModelFromFilters(filters: string) {
    if (filters[0] === '?') {
      filters = filters.substr(1);
    }

    for (const part of filters.split('&')) {
      const filterName = part.split('=')[0];
      const filterValue = part.split('=').slice(1).join('=');

      if (filterName === 'models') {
        return filterValue.split(':;').join(',');
      }
    }

    return 'all-models';
  }

  private getSearchFilterNames() {
    return ['models', 'version', 'fuelType', 'price_from', 'price_to', 'production_year', 'mileage', 'gearboxType', 'driveType',
      'enginePower_from', 'enginePower_to', 'color', 'interior_type', 'equipment', 'label', 'maxLength', 'maxHeight'];
  }

}
